import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  useClientApiV1MockInterviewsTypesQuery,
} from '../../resources/@types/studyAgentSchema';

interface UseClientV1MockInterviewsTypesQuery {
  options?: Parameters<typeof useClientApiV1MockInterviewsTypesQuery>[0]['options'];
}

export function useMockInterviewsTypesQuery({ options }: UseClientV1MockInterviewsTypesQuery = {}) {
  return useClientApiV1MockInterviewsTypesQuery({
    queryKey: getMockInterviewsTypesQueryKey(),
    url: getMockInterviewsTypesUrl(),
    options,
  });
}

export const getMockInterviewsTypesQueryKey = (): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEWS_TYPES,
];

export const getMockInterviewsTypesUrl = (): string => API_ENDPOINT.CLIENT_V1_MOCK_INTERVIEWS_TYPES;

export default useMockInterviewsTypesQuery;
